/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EventsCarsFilter = {
    /**
     * `true` - select only acknowledged events (do not require acknowledgement), `false` - select only unacknowledged events
     */
    acknowledged?: boolean;
    /**
     * `true` - select only events with backward intersected line. `false` - select only events intersected line in one direction.
     */
    backward_line_crossing?: boolean;
    /**
     * Select events where `features.body.name` takes one of these values
     */
    body?: Array<'cab' | 'convertible' | 'coupe' | 'crossover' | 'limousine' | 'minibus' | 'minivan' | 'sedan' | 'suv' | 'wagon'>;
    /**
     * Select events where `features.body.confidence` is **greater than or equal** to this value
     */
    body_score_gte?: number;
    /**
     * Select events where `features.body.confidence` is **less than or equal** to this value
     */
    body_score_lte?: number;
    /**
     * Select objects where `bs_type` takes one of these values
     */
    bs_type?: 'overall' | 'realtime';
    /**
     * Get events from these `camera groups`
     */
    camera_groups?: Array<number>;
    /**
     * Get events from these `cameras`
     */
    cameras?: Array<number>;
    /**
     * Select events related to these `cases`
     */
    case_in?: Array<number>;
    /**
     * Select events where `features.category.confidence` is **greater than or equal** to this value
     */
    category_score_gte?: number;
    /**
     * Select events where `features.category.confidence` is **less than or equal** to this value
     */
    category_score_lte?: number;
    /**
     * Select events where `features.category.name` takes one of these values
     */
    category_type?: Array<string>;
    /**
     * Select events where `features.color.name` takes one of these values
     */
    color?: Array<'beige' | 'black' | 'blue' | 'brown' | 'cyan' | 'gold' | 'green' | 'grey' | 'orange' | 'pink' | 'purple' | 'red' | 'silver' | 'violet' | 'white' | 'yellow'>;
    /**
     * Select events where `features.color.confidence` is **greater than or equal** to this value
     */
    color_score_gte?: number;
    /**
     * Select events where `features.color.confidence` is **less than or equal** to this value
     */
    color_score_lte?: number;
    /**
     * Select objects with `created_date` **greater than or equal** to this value
     */
    created_date_gte?: string;
    /**
     * Select objects with created in last N days
     */
    created_date_last_n_days?: number;
    /**
     * Select objects with `created_date` **less than or equal** to this value
     */
    created_date_lte?: string;
    /**
     * Select objects with created in last Nth week (including Sunday and Saturday)
     */
    created_date_nth_full_week?: number;
    /**
     * Select objects with created in last Nth week (only working days, i.e. excluding Sunday and Saturday)
     */
    created_date_nth_work_week?: number;
    /**
     * Select events that matched this episode
     */
    episode?: number;
    /**
     * Select events that created by external detectors
     */
    external_detector?: boolean;
    /**
     * `true` - select only events relates to case. `false` - select only events without case.
     */
    has_case?: boolean;
    /**
     * Exact filter by ID
     */
    id?: number;
    /**
     * Select objects with `id` **greater than or equal** to this value
     */
    id_gte?: number;
    /**
     * Select objects with provided ids
     */
    id_in?: Array<string>;
    /**
     * Select objects with `id` **less than or equal** to this value
     */
    id_lte?: number;
    /**
     * Select events where `latitude` is **greater than or equal** to this value
     */
    latitude_gte?: number;
    /**
     * Select events where `latitude` is **less than or equal** to this value
     */
    latitude_lte?: number;
    /**
     * Select events where `features.license_plate_country.name` takes one of these values
     */
    license_plate_country?: Array<'AE' | 'AM' | 'AR' | 'AZ' | 'BH' | 'BR' | 'BY' | 'CN' | 'CO' | 'CZ' | 'EG' | 'EST' | 'FIN' | 'GE' | 'IN' | 'IQ' | 'IR' | 'JO' | 'JP' | 'KG' | 'KR' | 'KW' | 'KZ' | 'LT' | 'LV' | 'MA' | 'MD' | 'MN' | 'MX' | 'OM' | 'PE' | 'PK' | 'PS' | 'QA' | 'RU' | 'SA' | 'SG' | 'SRB' | 'TH' | 'TJ' | 'TM' | 'TN' | 'TR' | 'UA' | 'UZ' | 'VN' | 'ZA' | 'unknown'>;
    /**
     * Select events where `features.license_plate_country.confidence` is **greater than or equal** to this value
     */
    license_plate_country_score_gte?: number;
    /**
     * Select events where `features.license_plate_country.confidence` is **less than or equal** to this value
     */
    license_plate_country_score_lte?: number;
    /**
     * Select events where `features.license_plate_number_color` takes one of these values
     */
    license_plate_number_color?: Array<string>;
    /**
     * Select events where `features.license_plate_number_color.confidence` is **greater than or equal** to this value
     */
    license_plate_number_color_score_gte?: number;
    /**
     * Select events where `features.license_plate_number_color.confidence` is **less than or equal** to this value
     */
    license_plate_number_color_score_lte?: number;
    /**
     * Select events where `features.model.license_plate_number` contains provided string(case insensitive)
     */
    license_plate_number_contains?: Array<string>;
    /**
     * Select events where `features.license_plate_number.confidence` is **greater than or equal** to this value
     */
    license_plate_number_score_gte?: number;
    /**
     * Select events where `features.license_plate_number.confidence` is **less than or equal** to this value
     */
    license_plate_number_score_lte?: number;
    /**
     * Select events where `features.license_plate_region.name` takes one of these values
     */
    license_plate_region?: Array<string>;
    /**
     * Select events where `features.license_plate_region.confidence` is **greater than or equal** to this value
     */
    license_plate_region_score_gte?: number;
    /**
     * Select events where `features.license_plate_region.confidence` is **less than or equal** to this value
     */
    license_plate_region_score_lte?: number;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * Select events that intersects with this lines
     */
    line?: Array<number>;
    /**
     * Select events that intersect line in these directions
     */
    line_crossing_direction?: Array<'AB' | 'BA' | 'none'>;
    /**
     * Select events where `longitude` is **greater than or equal** to this value
     */
    longitude_gte?: number;
    /**
     * Select events where `longitude` is **less than or equal** to this value
     */
    longitude_lte?: number;
    /**
     * Select events with faces similar to: (`detection:<detection id>`, `{face, body or car}object:<object id>`, `{face, body or car}event:<event id>`, `{face, body or car}cluster:<cluster id>` or `casecluster:<casecluster id>`). You can pass several search sources to search for. Pagination works if there is only one face to search for and if the sorting order is id. In all other cases, only the first page of results is returned
     */
    looks_like?: string;
    /**
     * Select events where `features.make.name` takes one of these values
     */
    make?: Array<'aabenraa' | 'abarth' | 'ac' | 'acura' | 'adler' | 'adria' | 'aebi' | 'aec' | 'aero' | 'ail' | 'aiways' | 'aixam' | 'ajokki' | 'alexander_dennis' | 'alfa_busz' | 'alfa_romeo' | 'alpina' | 'alpine' | 'alpus' | 'alvis' | 'am_general' | 'amc' | 'anadol' | 'andecar' | 'ankai' | 'arca' | 'ariel' | 'aro' | 'ashok_leyland' | 'asia' | 'aston_martin' | 'astra' | 'auburn' | 'audi' | 'aurus' | 'austin' | 'austin_healey' | 'auto_union' | 'autobianchi' | 'autosan' | 'avia' | 'avtokam' | 'avtostil' | 'ayats' | 'baic' | 'bajaj' | 'barkas' | 'baz' | 'beauford' | 'bedford' | 'beifang_benchi' | 'belarus' | 'belaz' | 'belkamunmash' | 'benimar' | 'bentley' | 'berkhof' | 'berliet' | 'bertone' | 'best_n' | 'bestune' | 'beulas' | 'bilenkin' | 'bioauto' | 'bitter' | 'bizzarrini' | 'blakely' | 'blue_bird' | 'bmc' | 'bmw' | 'bogdan' | 'bohse' | 'bollore' | 'bond' | 'bonum' | 'borgward' | 'bova' | 'bowler' | 'bradley' | 'bremach' | 'bricklin' | 'brilliance' | 'bristol' | 'bryanskiy_arsenal' | 'bucher' | 'buell' | 'bugatti' | 'buick' | 'bumar_fablok' | 'burillo' | 'burstner' | 'burton' | 'byd' | 'cacciamali' | 'cadillac' | 'caetano' | 'camc' | 'can_am' | 'carado' | 'caravans_international' | 'carrus' | 'carthago' | 'castrosua' | 'caterham' | 'challenger' | 'chana' | 'changan' | 'changfeng' | 'changhe' | 'chausson' | 'chaz' | 'cherkassy_bus' | 'chery' | 'chetra' | 'chevrolet' | 'chicago_pneumatic' | 'chrysler' | 'chsdm' | 'chtz' | 'chzpt' | 'chzsa' | 'ciimo' | 'cimc' | 'cisitalia' | 'citroen' | 'claas' | 'clenet' | 'cmc' | 'cnhtc' | 'coachmen' | 'cobus' | 'colani' | 'comarth' | 'comil_pia' | 'commer' | 'compass' | 'concorde' | 'cord' | 'cowin' | 'crobus' | 'crrc' | 'cs_reisemobile' | 'csepel' | 'cttm' | 'cukurova' | 'cunningham' | 'cupra' | 'currus' | 'dab' | 'dacia' | 'dadi' | 'daelim' | 'daewoo' | 'daf' | 'daihatsu' | 'daimler' | 'daimler_dmg' | 'dajiang' | 'dallara' | 'damon' | 'darracq' | 'datsun' | 'david' | 'dax' | 'dayun' | 'daz' | 'db' | 'de_dion_bouton' | 'de_simon' | 'de_tomaso' | 'delage' | 'delahaye' | 'delorean_motor_company' | 'delta' | 'demag' | 'den_oudsten' | 'dennis' | 'denolf_and_depla' | 'denza' | 'derways' | 'desna' | 'desoto' | 'dethleffs' | 'dfsk' | 'dino' | 'dkw' | 'dodge' | 'dongben' | 'dongfeng' | 'doninvest' | 'donkervoort' | 'doosan' | 'dormash' | 'dorteller' | 'dr_motor_company' | 'dragon_motor_company' | 'drogmoller' | 'ds' | 'duesenberg' | 'duple' | 'durso' | 'dutton' | 'dw_hower' | 'dypety' | 'eagle' | 'east_lancs' | 'easymile' | 'ebro' | 'ebusco' | 'edsel' | 'effedi' | 'elaz' | 'elddis' | 'electra_meccanica' | 'electron' | 'elmash' | 'elnagh' | 'emelba' | 'emgrand' | 'englon' | 'eos' | 'erf' | 'eriba' | 'erikoiskori' | 'ernst_auwarter' | 'essex' | 'estrima' | 'etuk_factory' | 'eura_mobil' | 'everus' | 'evropritsep' | 'excalibur' | 'exeed' | 'faw' | 'feifan' | 'ferrari' | 'fiat' | 'fisker' | 'ford' | 'forest_river' | 'fornasari' | 'foton' | 'foxbus' | 'foxtank' | 'frankia' | 'frazer_nash' | 'freight_rover' | 'freightliner' | 'fresia' | 'fsc_lublin' | 'fsm' | 'fso' | 'ftf' | 'fuqi' | 'gac' | 'gaz' | 'geely' | 'genesis' | 'geo' | 'gmc' | 'great_wall' | 'haargaz' | 'hafei' | 'haima' | 'hainje' | 'hako' | 'halaz' | 'hankuk_fiber' | 'hanomag' | 'hansa' | 'hanteng' | 'harbin' | 'hartung' | 'hatehof_carmor' | 'haval' | 'hawk' | 'hawtai' | 'healey' | 'heinkel' | 'helmark' | 'hengtong' | 'henschel' | 'hess' | 'heuliez' | 'higer' | 'hillman' | 'hindustan' | 'hino' | 'hiphi' | 'hispano' | 'hispano_aleman' | 'hispano_suiza' | 'hobby' | 'hodgep' | 'holden' | 'holiday_rambler' | 'hommell' | 'honda' | 'hongqi' | 'hongyan' | 'honker' | 'horch' | 'hotchkiss' | 'hsv' | 'huabei' | 'huanda' | 'huanghai' | 'huansu' | 'huasong' | 'huaxi' | 'huaxia' | 'huayu' | 'hudson' | 'huizhong' | 'humber' | 'hummer' | 'hupmobile' | 'hurtan' | 'hycan' | 'hydros' | 'hymer' | 'hyosung' | 'hyundai' | 'ic' | 'ifa' | 'ig' | 'ikarbus' | 'ikarus' | 'imperial' | 'imv' | 'indcar' | 'infiniti' | 'innocenti' | 'international' | 'interpipevan' | 'intrall' | 'invicta' | 'ipv' | 'iran_khodro' | 'irbis' | 'irisbus' | 'irizar' | 'irmaos_mota' | 'irmscher' | 'iso' | 'istok' | 'isuzu' | 'itala' | 'italjet' | 'itasca' | 'itineo' | 'iveco' | 'izh' | 'jac' | 'jaguar' | 'jba' | 'jdm' | 'jeep' | 'jelcz' | 'jensen' | 'jetour' | 'jetta' | 'jiangnan' | 'jide' | 'jinbei' | 'jinghua' | 'jit_luen' | 'jmc' | 'joint' | 'jonckheere' | 'jowett' | 'joylong' | 'jungheinrich' | 'jyki' | 'kabe' | 'kaipan' | 'kaiser' | 'kamaz' | 'kandi' | 'kapena' | 'kapri' | 'karosa' | 'karry' | 'karsan' | 'kato' | 'kavz' | 'kaz' | 'kenworth' | 'khaz' | 'khazar' | 'khtz' | 'kia' | 'kiitokori' | 'king_long' | 'kirovets' | 'kleinschnittger' | 'kmz' | 'knaus' | 'kobelco' | 'koenigsegg' | 'komatsu' | 'kougar' | 'kravtex' | 'kraz' | 'krone' | 'krupp' | 'kuban' | 'kutsenits' | 'kutter' | 'kuzbass' | 'kyburz' | 'kzkt' | 'lafer_s_a' | 'lag' | 'lagonda' | 'lahti' | 'laika' | 'lamberet' | 'lamborghini' | 'lambretta' | 'lancia' | 'land_rover' | 'landwind' | 'laz' | 'ldv' | 'levc' | 'lexus' | 'leyland' | 'liaz' | 'liaz_cz' | 'liebherr' | 'lifan' | 'ligier' | 'lincoln' | 'livezone' | 'lmc' | 'lohr' | 'london_taxi_company' | 'lotos' | 'lotus' | 'lti' | 'ltz' | 'luaz' | 'luxgen' | 'lynk_and_co' | 'lza' | 'mabi' | 'mack' | 'magirus_deutz' | 'mahindra' | 'malaguti' | 'man' | 'maple' | 'marbus' | 'marcopolo' | 'marcos' | 'marlin' | 'marmon' | 'marussia' | 'maruti' | 'marz' | 'maserati' | 'mash' | 'mat' | 'mathis' | 'matra' | 'maxus' | 'maybach' | 'maz' | 'maz_man' | 'mazda' | 'mbk' | 'mclaren' | 'mclouis' | 'mcv' | 'mcw' | 'mdt' | 'mega' | 'melkus' | 'menarini' | 'mercedes' | 'mercedes_benz' | 'mercury' | 'merkavim' | 'merkur' | 'messerschmitt' | 'metrocab' | 'mettalist' | 'meyers' | 'mg' | 'mia_electric' | 'microcar' | 'midas' | 'minerva' | 'mini' | 'mitsubishi' | 'mitsuoka' | 'moaz' | 'mobilvetta' | 'moia' | 'montesa' | 'mordovagromash' | 'morelo' | 'morgan' | 'morgan_olson' | 'morris' | 'moscvich' | 'moskovit' | 'most' | 'motor_coach_industries' | 'mowag' | 'mpm' | 'mtm' | 'mudan' | 'multicar' | 'mv_agusta' | 'mz' | 'mzkt' | 'nabi' | 'napier' | 'nash' | 'nasteviya' | 'naveco' | 'neckar' | 'nefaz_nzas' | 'neman' | 'neobus' | 'neoplan' | 'neta' | 'new_flyer' | 'newcar' | 'newmar' | 'ng' | 'niesmann_plus_bischoff' | 'niewiadow' | 'nio' | 'nissan' | 'nizhegorodets' | 'noble' | 'noge' | 'noone' | 'norton' | 'nova_bus' | 'nova_trailers' | 'novosibarz' | 'npo_plavsk' | 'nsu' | 'ntts_evrika_trade' | 'nysa' | 'oaf' | 'oasa' | 'obradors' | 'oldsmobile' | 'oltcit' | 'om_officine_meccaniche' | 'omnibus' | 'omoda' | 'opel' | 'optare' | 'ora' | 'orion' | 'orlandi' | 'orolstroymash' | 'osca' | 'oshan_oushang' | 'oshkosh' | 'otokar' | 'otoyol' | 'packard' | 'padane' | 'pagani' | 'panhard' | 'pannonia' | 'panoz' | 'panther' | 'pars_khodro' | 'patron' | 'paz' | 'peel' | 'pegaso' | 'perodua' | 'peterbilt' | 'peugeot' | 'pgmf' | 'pgo' | 'pgo_automobiles' | 'phoenix' | 'pierce' | 'pierce_arrow' | 'pilgrim' | 'pilote' | 'pla' | 'plasan' | 'plaxton' | 'plymouth' | 'pmz' | 'polaris' | 'polestar' | 'politrans' | 'polski_fiat' | 'pontiac' | 'porsche' | 'possl' | 'ppm' | 'praga' | 'prestigetrailers' | 'prevost' | 'prince' | 'pritsepvologdamash' | 'probus' | 'prodmash' | 'proton' | 'pskovavto' | 'ptz' | 'puch' | 'puma' | 'pyeonghwa' | 'qingqi' | 'qoros' | 'quadro' | 'qvale' | 'raba' | 'racer' | 'radical' | 'raf' | 'rally' | 'ram' | 'rambler' | 'rampini' | 'ramseier_and_jenzer' | 'randon' | 'rapido' | 'ravon' | 'rayton_fissore' | 'reform_muli' | 'reliant' | 'renault' | 'reo' | 'repstad' | 'reva' | 'rewaco' | 'reynolds_boughton' | 'riich' | 'riley' | 'rimac' | 'rimor' | 'riocar' | 'rm' | 'rm_terex' | 'rmz' | 'roarz' | 'roaz' | 'robur' | 'rocar' | 'rockwood' | 'roding' | 'roewe' | 'rolfo' | 'roller_team' | 'rolls_royce' | 'rom_carmel' | 'roman' | 'romanital' | 'romet' | 'ronart' | 'roosevelt' | 'rosenbauer' | 'rosengart' | 'rosero_p' | 'rover' | 'royal_enfield' | 'ruf' | 'rugby' | 'rusich' | 'russcan' | 'russo_baltique' | 'ruta' | 'saab' | 'saffle' | 'saipa' | 'saleen' | 'salmson' | 'samauto' | 'samco' | 'samsung' | 'sanos' | 'santana' | 'sany' | 'sarmat' | 'saturn' | 'saurer' | 'scam' | 'scania' | 'schmitz' | 'scion' | 'seat' | 'seaz' | 'secma' | 'seddon_atkinson' | 'semar' | 'semaz' | 'senova' | 'seres' | 'sespel' | 'setra' | 'shacman_shaanxi' | 'shanghai_maple' | 'shaolin' | 'shuanghuan' | 'shuchi' | 'siata' | 'siata_espanola' | 'sibtral_kzap_kzpt' | 'silant' | 'silence' | 'simaz' | 'simca' | 'singer' | 'sisu' | 'sitcar' | 'ski_doo' | 'skoda' | 'skywell' | 'sma' | 'smart' | 'smit' | 'smz' | 'sokon' | 'solaris' | 'solbus' | 'sor' | 'soueast' | 'spartan_cars' | 'specpricep' | 'spetsavtokam' | 'spier' | 'spijkstaal' | 'spyker' | 'ssang_yong' | 'staco' | 'standard' | 'star' | 'start' | 'stavpritsep' | 'stels' | 'sterling' | 'steyr' | 'stryi_avto' | 'studebaker' | 'subaru' | 'sun_living' | 'sunbeam' | 'sunlight' | 'sunlong_shenlong' | 'sunsundegui' | 'suzuki' | 'swift_motorhomes' | 'tabbert' | 'tadano' | 'tagaz' | 'tajikistan' | 'talbot' | 'tam' | 'tank' | 'tarpan' | 'tart' | 'tata' | 'tatra' | 'tavmz' | 'taz' | 'tazzari' | 'tec' | 'tecnobus' | 'temsa' | 'terberg' | 'terex' | 'terex_demag' | 'tesla' | 'tgb' | 'thaco' | 'think' | 'thomas' | 'thor' | 'tianjin_faw_huali' | 'tianjin_faw_xiali' | 'tianma' | 'tianye' | 'tiema' | 'tiffin' | 'tilbury' | 'tmt_motors' | 'tofas' | 'tojeiro' | 'tomassini' | 'tomos' | 'tonar' | 'tongxin' | 'toyota' | 'trabant' | 'transles' | 'transport_ttm' | 'trekol' | 'triumph' | 'trojan' | 'trolza' | 'trumpchi' | 'tur' | 'tverstroimash' | 'tvr' | 'uaz' | 'ud_trucks' | 'ugarte' | 'ultima' | 'umg_sdm' | 'umm' | 'unic' | 'unvi' | 'ural' | 'uralets' | 'uro' | 'ursus' | 'utic' | 'uzst' | 'van_hool' | 'vanden_plas' | 'vanderhall' | 'varz' | 'vauxhall' | 'vaz' | 'vbk' | 'vdl' | 'veam_motor' | 'vehixel' | 'velorex' | 'vem' | 'venturi' | 'venucia' | 'veritas' | 'vest' | 'vetter' | 'vgtz' | 'viasa' | 'viking' | 'vinfast' | 'vis' | 'viseon' | 'vmtz' | 'vmz_trans_alfa' | 'voez' | 'voisin' | 'volgabus' | 'volkswagen' | 'volteis' | 'volvo' | 'vortex' | 'voyah' | 'vpg' | 'w_motors' | 'walter' | 'wanderer' | 'wartburg' | 'weinsberg' | 'weiwang' | 'weltmeister' | 'western_star' | 'westfalia' | 'westfield' | 'wey' | 'whippet' | 'white' | 'wiesmann' | 'wiima' | 'wikov' | 'willis' | 'willys' | 'wingamm' | 'winnebago' | 'witzco_trailer' | 'wolseley' | 'wrightbus' | 'wsk' | 'wuling' | 'wuzhoulong' | 'xcmg' | 'xev' | 'xgo' | 'xian' | 'xingguang' | 'xinkai' | 'xmoto' | 'xpeng' | 'yaaz' | 'yarovit' | 'yate' | 'yaxing' | 'yeraz' | 'yinlong' | 'yo_auto' | 'youngman' | 'youyi' | 'yuejin' | 'yueloong' | 'yutong' | 'zamyad' | 'zastava' | 'zaz' | 'zbrojovka' | 'zd' | 'zeekr' | 'zenvo' | 'zezts' | 'zhejiang' | 'zhongtong' | 'zil' | 'zimmer' | 'zis' | 'zonda' | 'zoomlion' | 'zotye' | 'zssh' | 'zundapp' | 'zx'>;
    /**
     * Select events where `features.make.confidence` is **greater than or equal** to this value
     */
    make_score_gte?: number;
    /**
     * Select events where `features.make.confidence` is **less than or equal** to this value
     */
    make_score_lte?: number;
    /**
     * Filter is deprecated
     */
    matched_card?: number;
    /**
     * Select events that matched these cards
     */
    matched_card_in?: Array<number>;
    /**
     * Select events that match a card included in these watch lists
     */
    matched_lists?: Array<number>;
    /**
     * Select events where `features.model.name` contains provided string(case insensitive)
     */
    model?: Array<string>;
    /**
     * Select events where `features.model.confidence` is **greater than or equal** to this value
     */
    model_score_gte?: number;
    /**
     * Select events where `features.model.confidence` is **less than or equal** to this value
     */
    model_score_lte?: number;
    /**
     * `true` - select only events without matches. `false` - select events only with matches.
     */
    no_match?: boolean;
    /**
     * Which field to use for ordering. Available values: id, -id. Available values for looks_like: -confidence, -looks_like_confidence, id, -id, confidence and looks_like_confidence ordering are equivalents
     */
    ordering?: string;
    /**
     * Select events where `features.orientation.name` takes one of these values
     */
    orientation?: Array<'back' | 'front' | 'side'>;
    /**
     * Select events where `features.orientation.confidence` is **greater than or equal** to this value
     */
    orientation_score_gte?: number;
    /**
     * Select events where `features.orientation.confidence` is **less than or equal** to this value
     */
    orientation_score_lte?: number;
    /**
     * Pagination cursor value.
     */
    page?: string;
    /**
     * Select events where `features.special_vehicle_type.name` contains provided string(case insensitive)
     */
    special_vehicle_type?: Array<'ambulance' | 'car_sharing' | 'cash_in_transit' | 'gas_service' | 'military' | 'not_special' | 'other_special' | 'police' | 'rescue_service' | 'road_service' | 'route_transport' | 'taxi'>;
    /**
     * Select events where `features.special_vehicle_type.confidence` is **greater than or equal** to this value
     */
    special_vehicle_type_score_gte?: number;
    /**
     * Select events where `features.special_vehicle_type.confidence` is **less than or equal** to this value
     */
    special_vehicle_type_score_lte?: number;
    /**
     * Similarity threshold for `looks_like`
     */
    threshold?: number;
    /**
     * Get events from these video archives
     */
    video_archive?: Array<number>;
    /**
     * Select events where `features.weight_type.name` takes one of these values
     */
    weight_type?: Array<'B_heavy' | 'B_light' | 'C_heavy' | 'C_light' | 'D_light' | 'D_long' | 'other'>;
    /**
     * Select events where `features.weight_type.confidence` is **greater than or equal** to this value
     */
    weight_type_score_gte?: number;
    /**
     * Select events where `features.weight_type.confidence` is **less than or equal** to this value
     */
    weight_type_score_lte?: number;
}
export const EmptyEventsCarsFilter: EventsCarsFilter = {
    acknowledged: undefined,
    backward_line_crossing: undefined,
    body: [],
    body_score_gte: undefined,
    body_score_lte: undefined,
    bs_type: undefined,
    camera_groups: [],
    cameras: [],
    case_in: [],
    category_score_gte: undefined,
    category_score_lte: undefined,
    category_type: [],
    color: [],
    color_score_gte: undefined,
    color_score_lte: undefined,
    created_date_gte: undefined,
    created_date_last_n_days: undefined,
    created_date_lte: undefined,
    created_date_nth_full_week: undefined,
    created_date_nth_work_week: undefined,
    episode: undefined,
    external_detector: undefined,
    has_case: undefined,
    id: undefined,
    id_gte: undefined,
    id_in: [],
    id_lte: undefined,
    latitude_gte: undefined,
    latitude_lte: undefined,
    license_plate_country: [],
    license_plate_country_score_gte: undefined,
    license_plate_country_score_lte: undefined,
    license_plate_number_color: [],
    license_plate_number_color_score_gte: undefined,
    license_plate_number_color_score_lte: undefined,
    license_plate_number_contains: [],
    license_plate_number_score_gte: undefined,
    license_plate_number_score_lte: undefined,
    license_plate_region: [],
    license_plate_region_score_gte: undefined,
    license_plate_region_score_lte: undefined,
    limit: 20,
    line: [],
    line_crossing_direction: [],
    longitude_gte: undefined,
    longitude_lte: undefined,
    looks_like: undefined,
    make: [],
    make_score_gte: undefined,
    make_score_lte: undefined,
    matched_card: undefined,
    matched_card_in: [],
    matched_lists: [],
    model: [],
    model_score_gte: undefined,
    model_score_lte: undefined,
    no_match: undefined,
    ordering: '-id',
    orientation: [],
    orientation_score_gte: undefined,
    orientation_score_lte: undefined,
    page: undefined,
    special_vehicle_type: [],
    special_vehicle_type_score_gte: undefined,
    special_vehicle_type_score_lte: undefined,
    threshold: undefined,
    video_archive: [],
    weight_type: [],
    weight_type_score_gte: undefined,
    weight_type_score_lte: undefined,
}